<script>
import Layout from "../../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';
import moment from 'moment';
//import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "@vueform/multiselect/themes/default.css";
import Swal from "sweetalert2";

export default {
    page: {
        title: "Aging Report",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role:localStorage.getItem('role'),
            title: "Aging Report",
            items: [
                {
                text: "Aging Report",
                href: "/",
                },
            ],

            rangeDateconfig: {
                mode: "range",
                dateFormat: "Y-m-d",
            },
        
            customer_outstanding_invoice:[],
            customer_name:'',
            customer_email:'',
            customer_tenure:'',
            customer_phone_number:'',
            total_outstanding_amount:'',
            loadingDetail:false,
            loadingRoles:true,
            ButtonSeen:true,
            date: '',
            key_search:'',
            invoice_sts:'',
            dtKey:0,
            
      
        };
    },

    methods: {
    getCurrency() {
            return process.env.VUE_CURRENCY || 'SGD';
        },

        format_date(value){
            if (value) {
                return moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
            }
        },

        getCustomerInfo(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_AR_API_BASEURL+'customer/getCustomerInfo/'+this.$route.params.cid)
            .then(response => {
                if (response) {
                    this.customerInfo = response.data;
                    //console.log(this.customerInfo);
                    this.customer_name = this.customerInfo.name_as_per_nric;
                    this.customer_email = this.customerInfo.email;
                    this.customer_phone_number = this.customerInfo.phone_number;
                    this.customer_tenure = this.customerInfo.subscription_period;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        getInvoiceListing(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_AR_API_BASEURL+'invoice/OutstandingInvoicesListingById/'+this.$route.params.cid)
            .then(response => {
                if (response) {
                    this.loadingRoles=false;
                    this.customer_outstanding_invoice = response.data;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        getTotalOutstandingAmount(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_AR_API_BASEURL+'invoice/OutstandingAmountById/'+this.$route.params.cid)
            .then(response => {
                if (response) {
                    this.resultdata = response.data;
                    this.total_outstanding_amount = this.resultdata[0].total_outstanding;
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        sendReminder()
        {
            Swal.fire({
                title: "Are you sure you want to send email reminder to this customer?",
                icon: "info",
                showCancelButton: true,
                cancelButtonColor: "#f46a6a",
                confirmButtonColor: "#34c38f",
                confirmButtonText: "Yes, Send Now",
            }).then((result) => {
                if (result.value) {
                    const posting_ = {
                        'customer_id'  : this.$route.params.cid,
                        'customer_name'  : this.customer_name,
                        'customer_email'  : this.customer_email,
                        'customer_outstanding'  : this.total_outstanding_amount,
                    };
                    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                    axios.post(process.env.VUE_APP_AR_API_BASEURL+'invoice/sendOutstandingEmailReminder', posting_ )
                    .then(response => {
                        console.log(response);
                        if (response.status == 201||response.status == 200) {
                            Swal.fire({
                                title:"Email successfully sent.", 
                                icon:"success",
                            })
                        } 
                        else {
                            Swal.fire({
                                title:"Failed to send email.", 
                                icon:"warning",
                            })
                        }
                    }).catch(function (error) {                    
                        Swal.fire({
                            title:error.response.data.msj, 
                            icon:"warning",
                        })
                    });
                }
            });
        },

        calculateOutstanding(item) {
            const totalAmount = Number(item.total_amount);
            const latePaymentCharges = Number(item.late_payment_charges);
            const paidAmount = Number(item.paid_amount);
            const creditsApplied = Number(item.credits_applied);
            const outstandingAmount = totalAmount + latePaymentCharges - paidAmount - creditsApplied;
            return outstandingAmount.toFixed(2);
        }
    },

    components: {
        Layout,
        PageHeader,
        DataTable,
        //flatPickr,
    },

    mounted() {
        this.getInvoiceListing();
        this.getCustomerInfo();
        this.getTotalOutstandingAmount();
    },
    
};
require("@/assets/css/datatable.css");
</script>
<style>
/* .col-xl-8 {
    flex: 0 0 auto;
    width: 82.66667% !important;
} */
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!--button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#add_new_program_modal"  v-if="this.role = 1"><i class="ri-add-line align-middle me-1"></i> Add New Program</button> <br><br-->
        <!--div class="d-flex justify-content-end mb-3">
            <button @click="downloadExcel()" class="btn btn-success" v-if="this.role != 3"><i class="ri-file-excel-2-line align-middle me-1"></i> Export Excel</button><br><br>
        </div-->
        <div class="card">
            <div class="card-body border-bottom-dashed border-bottom">
                <div class="row g-4 align-items-center">
                    <div class="col-sm-6 p-3">
                        <div class="row mb-3">
                            <h5 class="card-title mb-0">{{ customer_name }}</h5>
                        </div>
                        <div class="row mb-1">
                            <div class="col-lg-3">
                                <label for="nameInput" class="form-label">Contact Number :</label>
                            </div>
                            <div class="col-lg-9">
                                {{ customer_phone_number }}
                            </div>
                        </div>
                        <div class="row mb-1">
                            <div class="col-lg-3">
                                <label for="nameInput" class="form-label">Email :</label>
                            </div>
                            <div class="col-lg-9">
                                {{ customer_email }}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-3">
                                <label for="nameInput" class="form-label">Tenure :</label>
                            </div>
                            <div class="col-lg-9">
                                {{ customer_tenure }} Months
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="row g-3 justify-content-end">
                            <div class="col-xl-4">
                                <div>
                                    <button type="button" class="btn btn-success w-100" @click='sendReminder()'>Send Reminder</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
            <div class="card-body">
                <div class="row g-3 justify-content-end">
                    <div class="col-sm-4">
                        <div class="row">
                        <label for="colFormLabel" class="col-sm-6 col-form-label col-form-label"><b>Total Outstanding ({{ this.getCurrency() }}) :</b></label>
                        <div class="col-sm-5">
                            <input type="email" class="form-control form-control" id="colFormLabelSm" v-model='total_outstanding_amount' readonly>
                        </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-body">
                <!--h6>** Orders data display from {{lastthirtyday()}} to {{currentDate()}}</h6-->
                <div class="live-preview">
                    <div class="row align-items-center g-12">
                        <div class="col-lg-12">
                            <div v-if='loadingRoles'>
                                <div class="spinner-border text-success" role="status">
                                    <span class="sr-only">Loading...</span>
                                </div>
                            </div>
                            <div v-else>
                                <div class="table-responsive">
                                    <DataTable :options="{lengthChange: false,searching: false}" :key="dtKey" class="table table-striped table-nowrap mb-0" id="example"> 
                                        <thead class="table-secondary">
                                            <tr>
                                                <th>#.</th>
                                                <th scope="col">Ref. No</th>                                                    
                                                <th scope="col">Due Date</th>
                                                <th scope="col" style="text-align: center">Monthly Amount ({{ this.getCurrency() }})</th>           
                                                <th scope="col" style="text-align: center">Late Payment Charge ({{ this.getCurrency() }})</th>           
                                                <th scope="col" style="text-align: center">Paid Amount ({{ this.getCurrency() }})</th>                                                         
                                                <th scope="col" style="text-align: center">Outstanding Amount ({{ this.getCurrency() }})</th>                                                         
                                            </tr>
                                        </thead>

                                        <tbody>                        
                                            <tr v-for="(item, index) in customer_outstanding_invoice" :key="index" class="content">
                                                <td>{{ index+1 }}</td>
                                                <td>{{item.invoice_no}}</td>                               
                                                <td>{{item.due_date}}</td>
                                                <td style="text-align: center">{{item.total_amount}}</td> 
                                                <td style="text-align: center">{{item.late_payment_charges}}</td> 
                                                <td style="text-align: center">{{item.paid_amount}}</td>                                      
                                                <td style="text-align: center">{{ calculateOutstanding(item) }}</td>    
                                            </tr>
                                        </tbody>
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>